module.exports = __webpack_public_path__ + "img/green.e7109f8f.png";